import { consentWordingFor, type ConsentOnFile } from '@aithora/shared';
import { I, sx } from './kit';

/**
 * The text and call consent box (AF-1566): unchecked by default, the exact V4 words from
 * @aithora/shared beside it (the server records the same words). Not needed to save or
 * verify a number; without it no alert texts or calls go to the number, push and in-app
 * still do. Same label style as the other settings checkboxes (Danger Zone).
 */
export function SmsConsentBox({ role, checked, onChange, disabled }: { role: string | null | undefined; checked: boolean; onChange: (on: boolean) => void; disabled?: boolean }) {
  return (
    <label data-testid="sms-consent-box" style={sx('display:flex;align-items:flex-start;gap:8px;font-size:16px;line-height:1.45;color:#3C454F;margin-top:4px;text-wrap:pretty;')}>
      <input type="checkbox" aria-label="I agree to texts and automated calls" checked={checked} disabled={disabled} onChange={(e) => onChange(e.target.checked)} style={sx('margin-top:2px;flex:0 0 auto;')} />
      <span>{I(consentWordingFor(role))}</span>
    </label>
  );
}

/** One line on the consent on file, for the person or their administrator. */
export function consentLine(c: ConsentOnFile | undefined | null): string {
  if (!c || !c.onFile) return 'No consent to texts and calls on file, so none go to this number (push and in-app still do).';
  const when = c.recordedAt ? new Date(c.recordedAt).toLocaleDateString([], { month: 'short', day: 'numeric', year: 'numeric' }) : '';
  const how: Record<string, string> = { console: 'ticked in the console', app: 'ticked in the app', paper: 'paper form', verbal: 'verbal', sms_keyword: 'texted START', web_form: 'web form' };
  const by = (c.source === 'paper' || c.source === 'verbal' || c.source === 'web_form') && c.recordedByName ? ', recorded by ' + c.recordedByName : '';
  return 'Agreed to texts and calls (' + (how[c.source ?? ''] ?? c.source ?? '') + (when ? ', ' + when : '') + by + '). STOP withdraws both.';
}
